import { createClient } from "@supabase/supabase-js";

const supabaseProjectId = process.env.REACT_APP_SUPABASE_PROJECT_ID;
const supabaseUrl = `https://${supabaseProjectId}.supabase.co`;
const publicAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const supabase = createClient(supabaseUrl, publicAnonKey);

export default supabase;
